<template>

</template>

<script>
export default {
  name: "add"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/product/add.vue